import _taggedTemplateLiteral from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import styled from 'styled-components';
import { getSpace } from '@yoweb/ui/styles/utils/theme';
import { theme } from '@yoweb/ui/styles';
import { Box } from '@yoweb/ui/components/Box';
import { Interactive } from '@yoweb/ui/components/typography';
import { CaretLeftIcon, CaretRightIcon, CloseIcon, DownloadIcon } from '@yoweb/ui/components/Icon';
import { ButtonIcon } from '@yoweb/ui/components/buttons';
import { Grid } from '@yoweb/ui/components/Grid';
import { media } from '@yoweb/ui/styles/utils';
import { useTranslation } from '@yoweb/next-i18next';
import { Modal } from './Modal';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ImageGalleryModal = function ImageGalleryModal(_ref) {
  var _ref$images = _ref.images,
      images = _ref$images === void 0 ? [] : _ref$images,
      _ref$imageIndex = _ref.imageIndex,
      imageIndex = _ref$imageIndex === void 0 ? 0 : _ref$imageIndex,
      setImageIndex = _ref.setImageIndex,
      onClose = _ref.onClose;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsx(Modal, {
    isOpen: images.length > 0,
    wrapContent: false,
    onClose: onClose,
    style: {
      overlay: {
        background: theme.colors.charcoal,
        zIndex: theme.zIndices.modal
      },
      content: {
        overflow: 'hidden',
        background: 'none',
        border: 'none',
        borderRadius: 0,
        height: '100vh',
        padding: 0,
        position: 'static',
        width: '100%'
      }
    },
    children: /*#__PURE__*/_jsxs(Grid, {
      rows: "auto 1fr",
      height: "100%",
      "data-testid": "image-gallery-container",
      children: [/*#__PURE__*/_jsxs(Box, {
        height: 72,
        display: "flex",
        justifyContent: "end",
        px: "medium1",
        gap: "normal3",
        children: [/*#__PURE__*/_jsxs(ImagePreviewAction, {
          display: "flex",
          alignItems: "center",
          gap: "small3",
          fontColor: "base000",
          "data-testid": "image-gallery-download-button",
          onClick: function onClick() {
            return window.location.href = "".concat(images[imageIndex], "/download");
          },
          children: [/*#__PURE__*/_jsx(DownloadIcon, {
            size: 24
          }), /*#__PURE__*/_jsx(Interactive, {
            variant: "infoLight",
            children: t('actions.download')
          })]
        }), /*#__PURE__*/_jsxs(ImagePreviewAction, {
          display: "flex",
          alignItems: "center",
          gap: "small3",
          onClick: onClose,
          fontColor: "base000",
          "data-testid": "image-gallery-close-button",
          children: [/*#__PURE__*/_jsx(CloseIcon, {
            size: 24
          }), /*#__PURE__*/_jsx(Interactive, {
            children: t('close')
          })]
        })]
      }), /*#__PURE__*/_jsxs(BodyGrid, {
        columns: "auto 1fr auto",
        gap: {
          _: 'small4',
          md: 'normal4'
        },
        height: "100%",
        children: [/*#__PURE__*/_jsx(Box, {
          display: "flex",
          alignItems: "center",
          minWidth: "normal4",
          children: imageIndex > 0 && /*#__PURE__*/_jsx(ButtonIcon, {
            size: {
              _: 'sm',
              md: 'md'
            },
            mode: "dark",
            variant: "primary",
            type: "button",
            isFloating: false,
            icon: /*#__PURE__*/_jsx(CaretLeftIcon, {
              fontSize: 20
            }),
            onClick: function onClick() {
              return setImageIndex(function (prev) {
                return prev - 1;
              });
            },
            bgColor: "base000",
            "data-testid": "image-gallery-back"
          })
        }), /*#__PURE__*/_jsx(Box, {
          height: "100%",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          children: /*#__PURE__*/_jsx("img", {
            src: images[imageIndex],
            alt: "",
            style: {
              maxWidth: '100%',
              maxHeight: '100%'
            }
          })
        }), /*#__PURE__*/_jsx(Box, {
          display: "flex",
          alignItems: "center",
          minWidth: "normal4",
          children: imageIndex < images.length - 1 && /*#__PURE__*/_jsx(ButtonIcon, {
            size: {
              _: 'sm',
              md: 'md'
            },
            mode: "dark",
            variant: "primary",
            type: "button",
            isFloating: false,
            icon: /*#__PURE__*/_jsx(CaretRightIcon, {
              fontSize: 20
            }),
            onClick: function onClick() {
              return setImageIndex(function (prev) {
                return prev + 1;
              });
            },
            bgColor: "base000",
            "data-testid": "image-gallery-next"
          })
        })]
      })]
    })
  });
};
var ImagePreviewAction = styled(Box).withConfig({
  componentId: "sc-10x2jvd-0"
})(["&&{cursor:pointer;}"]);
var BodyGrid = styled(Grid).withConfig({
  componentId: "sc-10x2jvd-1"
})(["&&{padding:0 ", " ", " ", ";", "}"], getSpace('small4'), getSpace('large1'), getSpace('small4'), media.md(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n     padding: 0 ", " ", " ", ";\n    "])), getSpace('medium1'), getSpace('large1'), getSpace('medium1')));